export default {"src":"/_next/static/media/mindbody.d999c43b.svg","height":36,"width":115,"blurWidth":0,"blurHeight":0};